import PlayModule from "./Play.module.scss";
import {usePlayOrStop} from "../../../../../components/Player";
import {FrontWebRadioModel} from "../../../../../generated";

type Props ={
    radio: FrontWebRadioModel
    className?: string
}
export const Play = (props: Props) => {

    const player = usePlayOrStop(props.radio)

    let className = PlayModule.Play;

    if (player.isLoading()) {
        className = PlayModule.Loading;
    }
    else if (player.isPlaying())
    {
        className = PlayModule.Stop;
    }

    return <a href={"#play"} className={`${className} ${props.className ?? ""} hvr-pop`} onClick={ev=>{
        ev.preventDefault();
        player.play();
    }} title={"Play"}>
    </a>

}